{
    "ChangeLayoutOptionTitle": "Cliquez pour voir les options de mise en page du tableau de bord.",
    "NAME": "ChangeLayout"
}